import React, { useContext } from 'react';
import LocaleContext from '../../../constants/localization';

const GroupTable = ({
  groups,
  setEdit,
  handleDelete,
  createdFromSSO,
  setSelectedGroup,
}) => {
  const LS = useContext(LocaleContext);

  const tableRows = groups.map((g) => (
    <tr className="user-table__row" key={g.id}>
      <td
        onClick={() => {
          setEdit(true);
          setSelectedGroup(g);
        }}
      >
        {g.name}
      </td>
      <td
        style={{
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <a
          className="manage-users--button__edit"
          onClick={() => {
            setEdit(true);
            setSelectedGroup(g);
          }}
        >
          {LS.manageGroups.edit} <i className="fa fa-edit" />
        </a>
        {!createdFromSSO && (
          <a
            className="manage-users--button__delete"
            onClick={() => handleDelete(g.id, g.name)}
          >
            {LS.manageGroups.delete} <i className="fa fa-trash" />
          </a>
        )}
      </td>
    </tr>
  ));

  return (
    <table className="group-table">
      <thead>
        <tr>
          <th style={{ textAlign: 'left' }}>{LS.manageGroups.groupName}</th>
          <th style={{ width: '20%' }}>{LS.manageUsers.tableQuickActions}</th>
        </tr>
      </thead>
      <tbody>{tableRows}</tbody>
    </table>
  );
};

export default GroupTable;
